import Component from '../../common/Component';
import Button from '../../common/components/Button';
import LinkButton from '../../common/components/LinkButton';
import Navigation from '../../common/components/Navigation';
import SelectDropdown from '../../common/components/SelectDropdown';
import listItems from '../../common/helpers/listItems';
import ItemList from '../../common/utils/ItemList';
import app from '../app';
import DiscussionComposer from './DiscussionComposer';
import LogInModal from './LogInModal';

export default class MobileHeader extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.hidden = false;
  }

  view() {
    if (this.hidden) return null;

    return <div class='mobile-header-container'>
      <img src="/assets/logo-i9omx2gb.png" />
    </div>;
  }



}
